module.exports = __webpack_public_path__ + "img/paper-plane-solid updated.0a18e70b.svg";